export default __webpack_public_path__ + "static/media/114t.6f03c21f.jpg";